export const SEARCH_FILTER = {
  UNKNOWN: 'Unbekannt',
};
